module.exports = __webpack_public_path__ + "static/olubunmi-4bc9459ba3644c04f9bdac945e5c9936.jpg";